/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 5/11/2021
 */
import {
	query,
	collection,
	doc,
	getDocs,
	onSnapshot,
	getCountFromServer,
	getAggregateFromServer,
	sum,
	average,
} from "firebase/firestore"

import BaseFirestoreRef from "@/core/js/backend/FIrebaseWrappers/ref/BaseFirestoreRef";
import DocRef from "@/core/js/backend/FIrebaseWrappers/ref/DocRef";

export default class CollectionRef extends BaseFirestoreRef{

	collectionRef

	constructor(firestore, ...paths) {
		super(firestore, ...paths)
		this.collectionRef = collection(firestore, ...paths)
	}

	doc(id){
		if(!id){
			let docRef = doc(this.collectionRef)
			id = docRef.id
		}
		// console.log("CollectionRef.doc: id = ", id, ", paths = ", this.paths)
		if(this.paths[0] === "genId"){
			return {id}
		}
		let paths = [...this.paths]
		paths.push(id)
		return new DocRef(this.firestore, ...paths)
	}

	onSnapshot(res, error){
		let q = this._buildQuery()
		console.log("CollectionRef.onSnapshot: q = ", q)
		return onSnapshot(q, res, error)
	}



	_buildQuery(){
		let queryConstraintsExecuted = this.getQueryConstraintsExecuted()
		console.log("CollectionRef._buildQuery = ", this.queryConstraints, ", this.paths = ", this.paths, ", queryConstraintsExecuted = ", queryConstraintsExecuted)
		return query(this.collectionRef, ...queryConstraintsExecuted)
	}

	async get(){
		let q = this._buildQuery()
		console.log("CollectionRef.get: q = ", q)
		return getDocs(q)
	}

	count(){
		return {
			get: async () => {
				let q = this._buildQuery()
				return getCountFromServer(q)
			}
		}
	}

	aggregate(params){
		return {
			get: async () => {
				let q = this._buildQuery()
				console.log("CollectionRef.aggregate.get: q = ", q, ", params = ", params)
				let res = await getAggregateFromServer(q, params)
				console.log("CollectionRef.aggregate.get: q = ", q, ", params = ", params, ", res = ", res)
				return res
			}
		}
	}


	getRef(){
		return this.collectionRef
	}


}
